import { createTheme } from "@mui/material/styles";
import { getFingerprint, setOption } from "@thumbmarkjs/thumbmarkjs";
import deepmerge from "deepmerge";


const mergeTheme = (base, second) => createTheme(deepmerge(base, second));

const is = {
	undefined: (value) => typeof value === "undefined"
};

const toBase64 = file => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = () => resolve(reader.result);
	reader.onerror = reject;
});

const fingerprint = async () => {
	setOption("exclude", ["permissions", "hardware.deviceMemory"]);
	setOption("logging", false);
	return await getFingerprint(true)
		.then((v) => {
			// if (import.meta.env.DEV) console.log("Subly-App fp:", v.hash, JSON.stringify(v.data, null, 2));
			return v.hash;
		})
		.catch((x) => { console.error(`Subly-App fp error: ${x}`); });
};

const prefetch = (url) => {
	const link = document.createElement("link");
	link.rel = "prefetch";
	link.href = url;
	document.head.appendChild(link);
};

export default {
	is,
	fingerprint,
	mergeTheme,
	prefetch,
	toBase64
};